export default "__VITE_ASSET__df98dd58__"